import gql from 'graphql-tag'

export const GetVezgoLink = gql`
    query GetVezgoLink($provider: String) {
        getConnectionLink(accountProvider: VEZGO, specificProvider: $provider) {
            expiration
            link
            link_token
            request_id
            status_code
        }
    }
`

export const GetVezgoServices = gql`
    query GetServices {
        getVezgoProviders {
            displayName
            authType
            credentials
            name
            logo
        }
    }
`

export const StoreCredential = gql`
    mutation MyMutation($code: String, $institution: String!) {
        storeCredential(
            input: { provider: VEZGO, code: $code, institution: $institution }
        )
    }
`
